// Short notes from an earlier version of this site (2024). Kept so that
// existing /blog/:id links continue to work.
export const notes = [
  {
    id: 1,
    title: "The Big Bang Theory: A Celebration of Nerd Culture",
    category: "TV Shows",
    date: "2024-03-15",
    body: "The Big Bang Theory revolutionized television by bringing science and nerd culture into mainstream entertainment. What makes this show special is its perfect blend of scientific accuracy and comedic timing. The characters, especially Sheldon Cooper, have become cultural icons. The show's ability to make complex scientific concepts accessible while maintaining humor is truly remarkable. It's not just a sitcom; it's a celebration of intelligence and the beauty of being different.",
  },
  {
    id: 2,
    title: "Breaking Bad: The Art of Character Transformation",
    category: "TV Shows",
    date: "2024-03-10",
    body: "Breaking Bad stands as a masterpiece in television history, primarily due to its exceptional character development. Walter White's transformation from a meek chemistry teacher to a drug kingpin is one of the most compelling character arcs ever written. The show's attention to detail, from the chemistry to the cinematography, creates an immersive experience. It's a study in how circumstances can change a person's moral compass and the consequences of those changes.",
  },
  {
    id: 3,
    title: "The Psychology of Money: A Must-Read for Financial Wisdom",
    category: "Books",
    date: "2024-03-05",
    body: "Morgan Housel's 'The Psychology of Money' is a refreshing take on personal finance that focuses on behavior rather than numbers. The book teaches that financial success isn't about intelligence or technical knowledge, but about understanding human behavior and emotions. Through 19 short stories, Housel explains how our relationship with money is shaped by our experiences and psychology. It's a book that will change how you think about wealth, risk, and financial decisions.",
  },
];
